export default "__VITE_ASSET__ecfb02f0__"